<template>
  <!-- Mismo cierre que la portada: del artículo al encargo -->
  <section class="mt-cierre">
    <div class="mt-contenedor mt-cierre__fila">
      <div>
        <h2>¿Tiene un trámite pendiente?</h2>
        <p>Cuéntenos qué necesita y elija una notaría cercana. En unos minutos, sin registrarse.</p>
      </div>
      <NuxtLink :to="ruta('/encargo-online')" class="mt-boton mt-boton--acento mt-boton--grande">
        Empezar mi encargo <v-icon size="20">mdi-arrow-right</v-icon>
      </NuxtLink>
    </div>
  </section>
</template>

<script setup lang="ts">
const route = useRouter().currentRoute
const ruta = (p: string) => (route.value.params.lang ? `/${route.value.params.lang}` : '') + p
</script>
